"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.canBookDate = void 0;
var dayjs_1 = __importDefault(require("dayjs"));
var getNextAvailableDay_1 = require("./getNextAvailableDay");
var utc_1 = __importDefault(require("dayjs/plugin/utc"));
var isDateBlackout_1 = require("./isDateBlackout");
dayjs_1.default.extend(utc_1.default);
var canBookDate = function (bookingDate, collectionDateConfig, day) {
    var _a;
    if (day === void 0) { day = dayjs_1.default.utc(); }
    var nextDay = (_a = (0, getNextAvailableDay_1.getNextAvailableDay)(collectionDateConfig, day)) === null || _a === void 0 ? void 0 : _a.toDate();
    if (!nextDay) {
        return false;
    }
    var isSameDayButBeforeCutOff = bookingDate.isSame(nextDay, "day") &&
        (bookingDate.isSame(nextDay, "hours") ||
            bookingDate.isBefore(nextDay, "hours"));
    var isAfterNextDay = bookingDate.isAfter(nextDay, "day");
    var isNotABlackout = !(0, isDateBlackout_1.isDateBlackout)(bookingDate, collectionDateConfig.blackoutDates || [], collectionDateConfig.blackoutDays || []);
    return (isSameDayButBeforeCutOff || isAfterNextDay) && isNotABlackout;
};
exports.canBookDate = canBookDate;
